module.exports = __webpack_public_path__ + "static/rekino-a6bc527a9eba5e5fe1b225ec61848818.png";